import Avatar from '@mui/material/Avatar';
import { getTrophyIcon } from './leaderboard.data';
import { leaderboardStyles as styles } from "./leaderboardStyles.tailwind";
import { filterString, getFirstCharUpperCase, getRandomColor } from '../../../../../../lib/constants/globalConstant';
import { useSelector } from 'react-redux';
import { useState } from 'react';
// import no_leaderboard from '../../../../../../assets/svgs/no_leaderboard_details.svg';
// import { throttle } from 'lodash';

const LeaderboardInfo = ({ playerData }) => {
  const { user } = useSelector((state) => state.user);
  const isUser = (id) => (user?.userDetails?._id === id);

  const [errorLoadingImage, setErrorLoadingImage] = useState(false);
  // const prevLeaderboard = useRef(playerData);
  // const [leaderboard, setLeaderboard] = useState(playerData);

  // const getMovementClass = (id, index) => {
  //   const prevIndex = prevLeaderboard.current.findIndex((player) => player.id === id);
  //   if (prevIndex > index) return styles.moveUp; // Player moved up
  //   if (prevIndex < index) return styles.moveDown; // Player moved down
  //   return '';
  // };

  // useEffect(() => {
  //   // Update the reference to the previous leaderboard state
  //   prevLeaderboard.current = leaderboard;
  // }, [leaderboard]);

  // useEffect(() => {
  //   const throttledUpdate = throttle(() => {
  //     setLeaderboard((prev) => {
  //       const updated = prev.map((player) => ({
  //         ...player,
  //         points: player.points + Math.floor(Math.random() * 20 - 10),
  //       }));
  //       return updated.sort((a, b) => b.points - a.points);
  //     });
  //   }, 1000);
    
  //   const interval = setInterval(throttledUpdate, 3000);

  //   return () => clearInterval(interval);
  // }, []);

  // if (!playerData || playerData.length === 0) { 
  //   return (
  //     <div className='flex flex-col items-center pb-2 gap-1'>
  //       <img src={no_leaderboard} alt="" className='max-w-[204px] h-auto w-full' />
  //       <p>No Points are awarded yet.</p>
  //     </div>
  //   );
  // }

  return (
    <div className={styles.dataContainer}>
      {/* Player Data */}
      {playerData?.map((player, index) => (
        <div
          key={index}
          className={`${styles.dataRow} ${isUser(player?._id?.userId) ? 'bg-liveGamePrimaryColor' : 'bg-themeColor'}`}
          // ${getMovementClass(player.id, index)}
          style={{
            transition: 'transform 0.5s ease, background-color 0.5s ease',
            // height: '60px', // Fixed height for rows
          }}
        >
          <div
            // trophy icons based on ranks(for rank 1, 2, 3)
            className={`${styles.rankDiv} 
              ${player?.rank === 1 ? styles.goldRank : player?.rank === 2 ? styles.silverRank : player?.rank === 3 ? styles.bronzeRank : ''}`}
          />
          
          <span className={styles.rank}>
            {player?.rank <= 3 ? (
              <img src={getTrophyIcon(player?.rank)} alt="Trophy" className={styles.trophyIcon} />
            ) : (
              player?.rank
            )}
          </span>

          {/* Player's Image */}
          <div className={styles.playerImageContainer}>
            {(player?.userProfileImageUrl && !errorLoadingImage) ? (
              <figure className={styles.figureContainer}> 
                <img src={player?.userProfileImageUrl} alt="Player" className={styles.playerImage} onError={() => setErrorLoadingImage(true)} />
              </figure>
            ) : (
              <Avatar sx={{
                  width: 30,
                  height: 30,
                  bgcolor: getRandomColor(getFirstCharUpperCase(player?.userNickName)),
                  border: `1px solid var(--liveGamePrimaryColor)`,
                  '@media(max-width: 499px)': {
                    width: 20,
                    height: 20,
                    fontSize: '10px'
                  }
                }}
              >
                {getFirstCharUpperCase(player?.userNickName)}
              </Avatar>
            )}
          </div>

          {/* Username */}
          <span className={styles.username}>{filterString(player?.userNickName)}</span>
          {/* <span className={styles.username}>{player?.userNickName}</span> */}
          {/* <span className='text-[8px] text-gray-100'>{player?.isUser && '(You)'}</span> */}

          {/* User Points */}
          <span className={styles.points}>{player?.tokenPoints}</span>
        </div>
      ))}
    </div>
  );
};

export default LeaderboardInfo;
